import script from "./DynamicUnderline.vue?vue&type=script&setup=true&lang=ts"
export * from "./DynamicUnderline.vue?vue&type=script&setup=true&lang=ts"

import "./DynamicUnderline.vue?vue&type=style&index=0&id=d460a6aa&scoped=true&lang=less"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d460a6aa"]])

export default __exports__